// istanbul ignore file

import * as yup from '@cld/yup-extra';

export type CookbookRecipeComplexity = 'beginner' | 'intermediate' | 'advanced';

export const cookbookRecipeComplexityDtoSchema = yup
  .object({
    complexity: yup.mixed<CookbookRecipeComplexity>().oneOf(['beginner', 'intermediate', 'advanced']).required(),
    recipesCount: yup.number().required(),
  })
  .required();

export type CookbookRecipeComplexityDto = yup.InferType<typeof cookbookRecipeComplexityDtoSchema>;
